



import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import PortfolioPage from './pages/Portfolio';
import ServicesPage from './pages/Services';
import AboutUsPage from './pages/About';
import ContactUsPage from './pages/Contact';
import Videos from './pages/blogs/Videos';
import Gallery from './pages/blogs/Gallery';
import FAQPage from './pages/Faq';
import ScrollToTop from './pages/ScrollToTop';

const App = () => {
    return (
        <Router>
            <Header />
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/about-us" element={<AboutUsPage />} />
                <Route path="/contact-us" element={<ContactUsPage />} />
                {/* <Route path="/blog" element={<BlogPage />} /> */}
                <Route path="/blogs/videos" element={<Videos />} />
                <Route path="/blogs/gallery" element={<Gallery />} />
                <Route path="/faq" element={<FAQPage />} />
            </Routes>
            <Footer />
        </Router>
    );
};

export default App;
